import { useQuery } from "react-query";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../firebase.init";

const API_BASE = process.env.REACT_APP_apiHostLink;

export const useAnalytics = (days = 7) => {
  const [user] = useAuthState(auth);

  return useQuery(
    ["analytics", days],
    async () => {
      const token = await user.getIdToken();
      const res = await fetch(`${API_BASE}/api/admin/analytics?days=${days}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to fetch analytics");
      return res.json();
    },
    { enabled: !!user, refetchInterval: 30000 }
  );
};
